import _ from "lodash";
import { getIn } from "formik";
import PropTypes from "prop-types";
import React from "react";

import { cn } from "@/lib/helpers/cn";

import { Dropdown } from "../../Dropdown";
import { FormFieldError } from "../FormFieldError/FormFieldError";
import { getAutomationDataAttr } from "../../../utils/automationUtils";
import "../styles.scss";

export const FormSelect = ({
  name,
  title,
  subTitle,
  placeholder,
  customError,
  className,
  dropDownClassName,
  formikProps,
  // normally form fields do not error until after submission
  // because they have not been touched
  // setting this to true triggers the error after editing
  // for the first time
  triggerErrorOnChange = false,
  disabled,
  options,
  dataPrivate,
  filterOptions,
  // a list of other field names whose errors this field should subscribe to
  otherErrorNames = [],
  // see comment in src/component-library/FormFields/FormTextArea/FormTextArea.jsx
  onChangeCallBack,
  testId,
}) => {
  const errorMessage = getIn(formikProps.errors, name);
  // get the other error messages
  const otherErrors = otherErrorNames
    .map((otherErrorName) => getIn(formikProps.errors, otherErrorName))
    .filter(Boolean);
  const isTouched = getIn(formikProps.touched, name);
  const value = _.get(formikProps.values, name);

  const handleChange = async (event) => {
    await formikProps.setFieldValue(name, event.target.value);

    if (!isTouched && triggerErrorOnChange) {
      await formikProps.setFieldTouched(name, true);
    }
    if (onChangeCallBack) {
      await onChangeCallBack(name, event.target.value);
    }
  };

  const selectedOption = options.find((item) => {
    return item.value === value;
  });

  return (
    <div className={cn("FormField-container", className)}>
      {title && (
        <strong data-public className="FormField-title">
          {title}
        </strong>
      )}

      {subTitle && (
        <span data-public className="FormField-subTitle">
          {subTitle}
        </span>
      )}

      <span data-private={dataPrivate}>
        <Dropdown
          className={cn("FormSelect", dropDownClassName)}
          error={isTouched && (errorMessage || otherErrors?.length > 0)}
          filterOptions={filterOptions}
          isDisabled={disabled}
          onChange={handleChange}
          options={options}
          placeholder={placeholder}
          value={selectedOption}
          {...getAutomationDataAttr(testId, "id")}
        />
      </span>

      {!customError && (errorMessage || otherErrors?.length > 0) && isTouched && (
        <FormFieldError otherErrors={otherErrors}>{errorMessage}</FormFieldError>
      )}

      {/* lets the dev pick what is displayed below the text area */}
      {customError && customError(value, errorMessage, isTouched)}
    </div>
  );
};

FormSelect.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  customError: PropTypes.func,
  formikProps: PropTypes.object,
  disabled: PropTypes.bool,
};
